//#region IMPORTAÇÕES
import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { BehaviorSubject, Observable } from "rxjs";
import { map } from "rxjs/operators";
import { ToastrService } from "ngx-toastr";
import { Product } from "../classes/product";
import { environment } from "../../../environments/environment";
import { AppService } from "../../app.service";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { EcomerceService } from "./ecommerce.service";
import { GrupoCaracteristicasProduto } from "../classes/caracteristicas";
//#endregion

const state = {
  wishlist: JSON.parse(localStorage["wishlistItems"] || "[]"),
  compare: JSON.parse(localStorage["compareItems"] || "[]"),
  cart: JSON.parse(localStorage["cartItems"] || "[]"),
  totalDescount: JSON.parse(localStorage["totalDesconto"] || "[]"),
  iconCupom: JSON.parse(localStorage["iconCupomAtivo"] || "[]"),
};

@Injectable({
  providedIn: "root",
})
export class ProductService {
  totalDesconto: number = 0;

  public Currency = { name: "dinheiro", currency: "BRL", price: 1 };
  public OpenCart: boolean = false;
  private productsListSubject: BehaviorSubject<Product[]> = new BehaviorSubject<
    Product[]
  >([]);
  public productsList$ = this.productsListSubject.asObservable();
  baseUrl = environment.baseUrl;
  public requestDone = false;
  location: string;
  constructor(
    private http: HttpClient,
    private toastrService: ToastrService,
    public appService: AppService,
    private modalService: NgbModal,
    private ecomerceService: EcomerceService
  ) {
    this.listarProdutos();
  }

  /*
    ---------------------------------------------
    ---------------  Product  -------------------
    ---------------------------------------------
  */

  setProducts(data: Product[], location: string) {
    this.requestDone = true;
    this.location = location;
    this.productsListSubject.next(data);
  }

  listarProdutos() {
    const location = localStorage.getItem("location");
    if (location && !this.requestDone) {
      this.location = location;
      this.ecomerceService.listarProdutos(location).subscribe(
        (data) => {
          this.requestDone = true;

          const productsArray: Product[] = [];
          data.forEach((e) => {
            productsArray.push(e);
          });

          this.productsListSubject.next(productsArray);
        },
        (error) => {
          console.error("Erro ao listar produtos:", error);
        }
      );
    }
  }

  public get getProducts(): Observable<Product[]> {
    return this.productsList$;
  }

  public getProductBySlug(slug: string): Observable<Product> {
    return this.getProducts.pipe(
      map((items) => {
        return items.find((item: any) => {
          return item.category.replace(" ", "-") === slug;
        });
      })
    );
  }

  public getProductById(id: number): Product {
    var produtos = [];
    this.productsList$.subscribe((response) => {
      produtos = response;
    });
    return produtos.find((x) => x.id == id);
  }

  listarGradeEstoque(idProduto: number) {
    return this.http.get<any>(
      `${this.baseUrl}api/Produto/listarGradeEstoque?idProduto=${idProduto}`
    );
  }

  listarCaracteristicasProduto(idProduto: number) {
    return this.http.get<GrupoCaracteristicasProduto[]>(
      `${this.baseUrl}api/Produto/listarCaracteristicasProduto?idProduto=${idProduto}`
    );
  }

  /*
    ---------------------------------------------
    ---------------  Wish List  -----------------
    ---------------------------------------------
  */

  // Get Wishlist Items
  public get wishlistItems(): Observable<Product[]> {
    const itemsStream = new Observable((observer) => {
      observer.next(state.wishlist);
      observer.complete();
    });
    return <Observable<Product[]>>itemsStream;
  }

  // Add to Wishlist
  public addToWishlist(product): any {
    const wishlistItem = state.wishlist.find((item) => item.id === product.id);
    if (!wishlistItem) {
      state.wishlist.push({
        ...product,
      });
    }
    this.toastrService.success("Produto adicionado a lista de desejos");
    localStorage.setItem("wishlistItems", JSON.stringify(state.wishlist));
    return true;
  }

  // Remove Wishlist items
  public removeWishlistItem(product: Product): any {
    const index = state.wishlist.indexOf(product);
    state.wishlist.splice(index, 1);
    localStorage.setItem("wishlistItems", JSON.stringify(state.wishlist));
    return true;
  }

  /*
    ---------------------------------------------
    -------------  Compare Product  -------------
    ---------------------------------------------
  */

  // Get Compare Items
  public get compareItems(): Observable<Product[]> {
    const itemsStream = new Observable((observer) => {
      observer.next(state.compare);
      observer.complete();
    });
    return <Observable<Product[]>>itemsStream;
  }

  // Add to Compare
  public addToCompare(product): any {
    const compareItem = state.compare.find((item) => item.id === product.id);
    if (!compareItem) {
      state.compare.push({
        ...product,
      });
    }
    this.toastrService.success("Produto adicionado a lista de comparação");
    localStorage.setItem("compareItems", JSON.stringify(state.compare));
    return true;
  }

  // Remove Compare items
  public removeCompareItem(product: Product): any {
    const index = state.compare.indexOf(product);
    state.compare.splice(index, 1);
    localStorage.setItem("compareItems", JSON.stringify(state.compare));
    return true;
  }

  /*
    ---------------------------------------------
    -----------------  Cart  --------------------
    ---------------------------------------------
  */

  // Get Cart Items
  public get cartItems(): Observable<Product[]> {
    const itemsStream = new Observable((observer) => {
      observer.next(state.cart);
      observer.complete();
    });
    return <Observable<Product[]>>itemsStream;
  }

  // Add to Cart
  public addToCart(product): any {
    const cartItem = state.cart.find((item) => item.id === product.id);
    const qty = product.quantity ? product.quantity : 1;
    const items = cartItem ? cartItem : product;
    const stock = this.calculateStockCounts(items, qty);

    if (!stock) return false;

    if (cartItem) {
      cartItem.quantity += qty;
    } else {
      state.cart.push({
        ...product,
        quantity: qty,
      });
    }

    this.OpenCart = true; // If we use cart variation modal
    //this.toastrService.success("Produto adicionado ao carrinho");
    this.appService.SwalSuccessss();
    localStorage.setItem("cartItems", JSON.stringify(state.cart));
    return true;
  }

  // Update Cart Quantity
  public updateCartQuantity(
    product: Product,
    quantity: number
  ): Product | boolean {
    return state.cart.find((items, index) => {
      if (items.id === product.id) {
        const qty = state.cart[index].quantity + quantity;
        const stock = this.calculateStockCounts(state.cart[index], quantity);
        if (qty !== 0 && stock) {
          state.cart[index].quantity = qty;
        }
        localStorage.setItem("cartItems", JSON.stringify(state.cart));
        return true;
      }
    });
  }

  // Calculate Stock Counts
  /* public calculateStockCounts(product, quantity) {
    const qty = product.quantity + quantity;
    const stock = product.stock;
    if (stock < qty || stock == 0) {
      this.toastrService.error(
        "You can not add more items than available. In stock " +
          stock +
          " items."
      );
      return false;
    }
    return true;
  } */

  // Calculate Stock Counts
  public calculateStockCounts(product, quantity) {
    const qty = quantity;
    const stock = product.stock;

    if (stock < qty || stock == 0) {
      this.toastrService.error(
        "Não é permitido colocar itens com estoque 0 no carrinho!" +
          stock +
          " items."
      );
      return false;
    }

    return true;
  }

  // Remove Cart items
  public removeCartItem(product: Product): any {
    const index = state.cart.indexOf(product);
    state.cart.splice(index, 1);
    localStorage.setItem("cartItems", JSON.stringify(state.cart));
    return true;
  }

  public removeDescontoCartItem(product: Product): boolean {
    const cartItems: Product[] = JSON.parse(
      localStorage.getItem("cartItems") || "[]"
    );
    const index = cartItems.findIndex((item) => item.id === product.id);

    if (index === -1) {
      console.error("Item not found in cart");
      return false;
    }

    if (product.valorDesconto > 0) {
      let totalDesconto = parseFloat(
        localStorage.getItem("totalDesconto") || "0"
      );
      if (product.tipoDesconto === "Porcentagem") {
        let discountAmount = (product.valorDesconto / 100) * product.price;
        totalDesconto -= discountAmount;
      } else if (product.tipoDesconto === "Real") {
        totalDesconto -= product.valorDesconto;
      }
      localStorage.setItem("totalDesconto", totalDesconto.toFixed(2));
    }

    cartItems.splice(index, 1);
    localStorage.setItem("cartItems", JSON.stringify(cartItems));

    return true;
  }

  // Total amount
  /*  public cartTotalAmount(): Observable<number> {
    return this.cartItems.pipe(
      map((product: Product[]) => {
        return product.reduce((prev, curr: Product) => {
          let price = curr.price;
          if (curr.discount) {
            price = curr.price - (curr.price * curr.discount) / 100;
          }

          const optionsValue = curr.opcoes?.length
            ? curr.opcoes.reduce((total, produto) => total + produto.valor, 0)
            : 0;

          return (
            (prev + optionsValue + price) * curr.quantity * this.Currency.price
          );
        }, 0);
      })
    );
  } */
  public cartTotalAmount(): Observable<number> {
    return this.cartItems.pipe(
      map((products: Product[]) => {
        return products.reduce((total, product) => {
          let price = product.price;
          if (product.discount) {
            price -= (product.price * product.discount) / 100;
          }

          const optionsValue =
            product.opcoes?.reduce(
              (optTotal, opcao) => optTotal + opcao.valor,
              0
            ) || 0;

          const frete = product.valorFrete || 0;

          const totalPriceForProduct =
            (price + optionsValue + frete) * product.quantity;

          return total + totalPriceForProduct;
        }, 0);
      })
    );
  }

  /*
    ---------------------------------------------
           --------  SOMAR FRETE ----------
    ---------------------------------------------
  */
  public cartAmountFrete(): Observable<number> {
    return this.cartItems.pipe(
      map((product: Product[]) => {
        return product.reduce((prev, curr: Product) => {
          let priceFrete = curr.valorFrete;

          return prev + priceFrete;
        }, 0);
      })
    );
  }

  public cartTotalAmountFrete(): Observable<number> {
    return this.cartItems.pipe(
      map((products: Product[]) => {
        let totalAmount = 0;
        products.forEach((item: Product) => {
          if (item.valorFrete) {
            totalAmount += item.valorFrete;
          }
        });
        return totalAmount;
      })
    );
  }

  public decrecerValorFrete(): Observable<number> {
    return this.cartItems.pipe(
      map((products: Product[]) => {
        let totalAmount = products.reduce((prev, curr: Product) => {
          let price = curr.price;
          if (curr.discount) {
            price = curr.price - (curr.price * curr.discount) / 100;
          }
          return (prev - price * curr.quantity) * this.Currency.price;
        }, 0);

        // Adicionar o valor do frete calculado para cada item que possui frete
        products.forEach((item: Product) => {
          if (item.valorFrete) {
            totalAmount -= item.valorFrete;
          }
        });

        return totalAmount;
      })
    );
  }

  /*
    ---------------------------------------------
    --------  APLICA DESCONTO DO CUPOM ----------
    ---------------------------------------------
  */

  public aplicarDesconto(cupom: string): string {
    let products: Product[] =
      JSON.parse(localStorage.getItem("cartItems")) || [];
    let totalDesconto = 0;

    products.forEach((product) => {
      if (product.cupomAtivo) {
        let discountAmount = 0;
        if (product.tipoDesconto === "Porcentagem") {
          discountAmount = (product.valorDesconto / 100) * product.price;
        } else if (product.tipoDesconto === "Real") {
          discountAmount = product.valorDesconto;
        }
        product.price -= discountAmount;
        totalDesconto += discountAmount;
      }
    });

    localStorage.setItem("cartItems", JSON.stringify(products));
    this.productsListSubject.next(products);
    return totalDesconto.toFixed(2);
  }

  public somaTotalDesconto() {
    let products: Product[] =
      JSON.parse(localStorage.getItem("cartItems")) || [];
    let totalDesconto = 0;

    products.forEach((item: Product) => {
      if (item.cupomAtivo) {
        if (item.tipoDesconto === "Porcentagem") {
          const discountAmount = (item.valorDesconto / 100) * item.price;
          totalDesconto += (item.price - discountAmount) * item.quantity;
        } else if (item.tipoDesconto === "Real") {
          totalDesconto += (item.price - item.valorDesconto) * item.quantity;
        }
      }
    });

    localStorage.setItem("totalDesconto", totalDesconto.toString());

    return totalDesconto;
  }

  /*
    ---------------------------------------------
    ------------  Filter Product  ---------------
    ---------------------------------------------
  */

  // Get Product Filter
  public filterProducts(filter: any): Observable<Product[]> {
    return this.getProducts.pipe(
      map((product) =>
        product.filter((item: Product) => {
          if (!filter.length) return true;
          const Tags = filter.some((prev) => {
            // Match Tags
            if (item.tags) {
              if (item.tags.includes(prev)) {
                return prev;
              }
            }
          });
          return Tags;
        })
      )
    );
  }

  // Sorting Filter
  public sortProducts(products: Product[], payload: string): any {
    if (payload === "ascending") {
      return products.sort((a, b) => {
        if (a.id < b.id) {
          return -1;
        } else if (a.id > b.id) {
          return 1;
        }
        return 0;
      });
    } else if (payload === "a-z") {
      return products.sort((a, b) => {
        if (a.title < b.title) {
          return -1;
        } else if (a.title > b.title) {
          return 1;
        }
        return 0;
      });
    } else if (payload === "z-a") {
      return products.sort((a, b) => {
        if (a.title > b.title) {
          return -1;
        } else if (a.title < b.title) {
          return 1;
        }
        return 0;
      });
    } else if (payload === "low") {
      return products.sort((a, b) => {
        if (a.price < b.price) {
          return -1;
        } else if (a.price > b.price) {
          return 1;
        }
        return 0;
      });
    } else if (payload === "high") {
      return products.sort((a, b) => {
        if (a.price > b.price) {
          return -1;
        } else if (a.price < b.price) {
          return 1;
        }
        return 0;
      });
    }
  }

  /*
    ---------------------------------------------
    ------------- Product Pagination  -----------
    ---------------------------------------------
  */

  public getPager(
    totalItems: number,
    currentPage: number = 1,
    pageSize: number = 16
  ) {
    let totalPages = Math.ceil(totalItems / pageSize);

    let startIndex = (currentPage - 1) * pageSize;
    let endIndex = Math.min(startIndex + pageSize - 1, totalItems - 1);

    let pages = Array.from(Array(totalPages).keys()).map((i) => i + 1);

    return {
      totalItems: totalItems,
      currentPage: currentPage,
      pageSize: pageSize,
      totalPages: totalPages,
      startIndex: startIndex,
      endIndex: endIndex,
      pages: pages,
    };
  }

  /*
    ---------------------------------------------
    ------------- Product Comments  -----------
    ---------------------------------------------
  */

  listarComentarioProdutoPorId(id: number): Observable<any> {
    return this.http.get<any>(
      `${this.baseUrl}api/Ecomerce/listarComentarioProduto/${id}`
    );
  }

  salvarComentarioNoProduto(comment: any): Observable<any> {
    return this.http.post<any>(
      `${this.baseUrl}api/ecomerce/salvarComentarioNoProduto`,
      comment
    );
  }
}
